import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import Notification from '../../components/Notification.js';
import Helmet from 'react-helmet';
import AppItem from './AppItem';
import Confirm from '../../components/Confirm.js';
import General from '../../modules/General';
import Raven from 'raven-js';

class AppBrowse extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			'apps':[],
			'askDelete':false,
			'isLoading':true
		}

		this.apps = [
			{
				title:'Mailchimp',
				description:'Synchronize campaign leads directly to mailchimp.',
				image:'/assets/images/apps/mailchimp.png',
				app:'Mailchimp',
			},
            {
                title:'Mailmojo',
                description:'Synchronize campaign leads directly to Mailmojo.',
                image:'/assets/images/apps/mailmojo.png',
				oauth:true,
                app:'Mailmojo',
            },
            {
                title:'Mailerlite',
                description:'Synchronize campaign leads directly to mailerlite.',
                image:'/assets/images/apps/mailerlite.png',
                app:'Mailerlite',
            },
			{
				title:'Apsis',
				description:'Synchronize campaign leads directly to apsis.',
				image:'/assets/images/apps/apsis.png',
				app:'Apsis',
			}
            ,
            {
                title:'Trustpilot',
                description:'Use Automatic feedback service in your order confirmations',
                image:'/assets/images/apps/trustpilot.png',
                app:'Trustpilot',
            },
            {
                title:'Facebook ads',
                description:'Synchronize segments to facebook audiences',
                image:'/assets/images/apps/facebook.png',
                oauth:true,
				hasOptions:true,
                app:'FacebookAds',
            }
		];


		this.isInstalled = this.isInstalled.bind(this);
		this.app = this.app.bind(this);
		this.uninstall = this.uninstall.bind(this);
		this.askUninstall = this.askUninstall.bind(this);
	}

	askUninstall(key) {
		this.setState({
			askDelete:key
		});
	}


	uninstall(key) {
		this.setState({
			askDelete:false,
			isLoading:true
		});

		axios.post('/apps/'+key+'/uninstall').then(res => {
			General.fetchGeneral().then(res => {
				this.setState({
					isLoading:false
				});
			}).catch(err => Raven.captureException(err));
		});
	}

	isInstalled(key) {
		for(let i in this.props.general.apps) {
			if(this.props.general.apps[i].key == key) {
				return true;
			}
		}

		return false;
	}

	app(item) {
		return <AppItem key={item.app} item={item} uninstall={(e) => {e.stopPropagation(); this.askUninstall(item.app)}} title={item.title} description={item.description} image={item.image} app={item.app} installed={this.isInstalled(item.app)}/>
	}



	componentWillMount() {
		General.fetchGeneral().then(res => {
			this.setState({
				isLoading:false
			});
        }).catch(err => Raven.captureException(res));
	}

	render() {

		if(this.state.isLoading) {
			return <Loading error={false} />
		}

		return (
			<div className="full-height">
				<Helmet title="Apps | Crall.io" />
				<div className="page-header">
					<span className="page-title"><i className="icon wb-extension"></i> Apps</span>
				</div>

				<div className="page-content">

					<OptionColumn title="Available apps" description="Install / configure apps">
						<ul className="list-group list-group-full">
							{this.apps.map(item => {
								return this.app(item);
							})}
						</ul>
					</OptionColumn>

				</div>
				<Confirm onAccept={(e) => { this.uninstall(e) }} onClose={() => {this.setState({askDelete:false})}} param={this.state.askDelete} title="Are you sure?" body="Do you want to uninstall this app?" />
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


AppBrowse = connect(mapStateToProps,mapDispatchToProps)(AppBrowse);
export default AppBrowse;



// WEBPACK FOOTER //
// ./containers/apps/AppBrowse.js